import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BypassSecurityTrustUrlPipe } from 'app/shared/bypass-security-trust-url.pipe'
import { TranslatePipe } from 'app/shared/translate.pipe'

import { LazyVideoComponent } from '../base/lazy-video.component'

function createIframeUrl(videoId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
    playsinline: '1',
    rel: '0',
  })
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`
}

@Component({
  selector: 'pai-lazy-youtube',
  imports: [BypassSecurityTrustUrlPipe, TranslatePipe],
  templateUrl: '../base/lazy-video.component.html',
  styleUrls: ['../base/lazy-video.component.scss', './lazy-youtube.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyYoutubeComponent extends LazyVideoComponent {
  get placeholderImageSrcUrl(): string {
    return `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`
  }

  get videoType(): string {
    return 'youtube'
  }

  protected warmup() {
    this.preconnectLinkService.add(
      'https://jnn-pa.googleapis.com',
      'https://www.youtube-nocookie.com',
      'https://www.google.com',
    )
  }

  protected initIframe(iframeEl: HTMLIFrameElement) {
    iframeEl.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    iframeEl.allowFullscreen = true
    iframeEl.src = createIframeUrl(this.videoId)
    iframeEl.frameBorder = '0'
  }
}
